import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-squid',
  templateUrl: './squid.component.html',
  styleUrls: ['./squid.component.scss']
})
export class SquidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
